/**
 * Created by Ning Jiang on 2022-06-23.
 */

import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";
import {Serial} from "../Serial";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {SerialSound} from "../sound/SerialSound";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Layers, SerialLayers} from "./SerialLayers";
import {gsap} from "gsap";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {MathHelper} from "../../core/utils/MathHelper";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class XBetButton extends GuiButton {

    private _disableTint = 0x666666;

    private _base:PIXI.Sprite;
    private _selected:PIXI.Sprite;
    private _unselected:PIXI.Sprite;
    private _enabledSparks:TimelineSprite;

    // 0=landscape 1=portrait
    constructor(index:number) {
        super("xBetButton");

        this._base = new PIXI.Sprite(Serial.assetLoader.getTextures(index === 0 ?
            "xbet/Switch_desktop" :
            "xbet/Switch_mobile"
        )[0]);
        this._base.position.set(index === 0 ? -25 : -470, index === 0 ? -46 : -28);
        this.addChild(this._base);

        this._selected = new PIXI.Sprite(Serial.assetLoader.getTextures('xbet/Flashlight')[0]);
        this._selected.anchor.set(0.5);
        this._selected.scale.set(0.2);
        this._selected.tint = 0x00FF00;
        this._selected.blendMode = PIXI.BLEND_MODES.ADD;
        this._selected.position.set(index === 0 ? 0 : -12, index === 0 ? -10 : 2);
        this.addChild(this._selected);

        this._unselected = new PIXI.Sprite(Serial.assetLoader.getTextures('xbet/Flashlight')[0]);
        this._unselected.anchor.set(0.5);
        this._unselected.scale.set(0.2);
        this._unselected.tint = 0xFF0000;
        this._unselected.blendMode = PIXI.BLEND_MODES.ADD;
        this._unselected.position.set(index === 0 ? 0 : 16, index === 0 ? 14 : 2);
        this.addChild(this._unselected);

        this._enabledSparks = new TimelineSprite(Serial.assetLoader.getTextures("XBetButtonSparksOn/XBetButtonSparksOn_"));
        this._enabledSparks.blendMode = PIXI.BLEND_MODES.ADD;
        this._enabledSparks.anchor.set(0.5);
        this._enabledSparks.position.set(index === 0 ? -2 : -2, index === 0 ? 4 : 0);
        this._enabledSparks.rotation = index === 0 ? 0 : (Math.PI * 0.5);
        this._enabledSparks.visible = false;
        this.addChild(this._enabledSparks);

        // const temp = new PIXI.Sprite(Serial.assetLoader.getTextures("XBetButtonSparksOn/XBetButtonSparksOn_")[4]);
        // temp.blendMode = PIXI.BLEND_MODES.ADD;
        // temp.anchor.set(0.5);
        // temp.position.set(index === 0 ? -2 : -2, index === 0 ? 4 : 0);
        // temp.rotation = index === 0 ? 0 : (Math.PI * 0.5);
        // this.addChild(temp);

        this.hitArea = index === 0 ?
            new PIXI.Rectangle(-24, -30, 52, 110) :
            new PIXI.Rectangle(-81, -18, 112, 36);

        // const textRect = new PIXI.Graphics();
        // textRect.beginFill(0xFF0000, 0.5);
        // if(index === 0) {
        //     textRect.drawRect(-24, -30, 52, 110);
        // } else {
        //     textRect.drawRect(-81, -18, 112, 36);
        // }
        // textRect.endFill();
        // this.addChild(textRect);
    }

    public enable(enable:boolean) {
        super.enable(enable);
        this._base.tint = enable ? 0xFFFFFF : this._disableTint;
        this._selected.visible = Serial.xBetController.selected;
        this._unselected.visible = enable && !Serial.xBetController.selected;
    }

    public playSparks():void {
        this._enabledSparks.getAnimationAutoShowHide();
    }
}

export class XBetController extends PIXI.Container {

    private _buttonLandscape:XBetButton;
    private _buttonPortrait:XBetButton;
    private _lamp:PIXI.spine.Spine;

    private _idleTl:gsap.core.Timeline | null;
    private _isIdling:boolean;

    private _featureAllowed:boolean;
    private _isFreeBet:boolean;

    public boostedName:string = "BOOSTED_BET";
    private _boostedData:any;

    private _buttonsVisible:boolean = false;

    public set buttonsVisible(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        if(this._isFreeBet) {
            value = false;
        }
        this._buttonsVisible = value;

        this._buttonLandscape.visible = this._buttonsVisible && NolimitApplication.isLandscape;
        this._buttonPortrait.visible = this._buttonsVisible && !NolimitApplication.isLandscape;
        this._lamp.visible = this._buttonsVisible;
    }

    public get buttonsVisible() {
        return this._buttonsVisible;
    }

    private _featureEnabled:boolean = false;

    public set featureEnabled(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }

        if(SlotGame.apiPlugin.isReplay) {
            value = false;
        }
        this._featureEnabled = value;
        this._buttonLandscape.enable(this._buttonLandscape.visible && this._featureEnabled);
        this._buttonPortrait.enable(this._buttonPortrait.visible && this._featureEnabled);

        const entry = this._lamp.state.getCurrent(0);
        if(this._selected && this._buttonsVisible) {
            if(entry && entry.animation.name.includes("Activate")) {
                return;
            }
            this._lamp.state.setAnimation(0, "Activate", false);
            const tl = gsap.timeline();
            tl.add(() => {
                if(this._selected && this._buttonsVisible) {
                    this._lamp.state.setAnimation(0, "ActivateLoop", true);
                }
            }, this._lamp.spineData.findAnimation("Activate").duration);
        } else {
            if(this._buttonsVisible) {
                if(entry) {
                    if(entry.animation.name === "End") {
                        return;
                    }
                } else {
                    if(Serial.model.parsedGameData) {
                        this._lamp.state.setAnimation(0, "End", false).time = this._lamp.spineData.findAnimation("End").duration;
                        return;
                    }
                }
                this._lamp.state.setAnimation(0, "End", false);
            }
        }
    }

    public get featureEnabled() {
        return this._featureEnabled;
    }

    private _selected:boolean;

    public set selected(value:boolean) {
        if(!this._featureAllowed) {
            return;
        }
        this._selected = value;
        this.featureEnabled = this._featureEnabled;
    }

    public get selected() {
        return this._selected;
    }

    constructor() {
        super();

        this._featureAllowed = Serial.apiPlugin.betFeatureController.getFeatureData("BOOSTED_BET") != undefined;
        if(!this._featureAllowed) {
            return;
        }

        this._lamp = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset("xBet"));
        this._lamp.autoUpdate = true;
        this._lamp.position.set(226, 378);
        SerialLayers.getLayer(Layers.XBET_LAMP)?.addChild(this._lamp);

        this._buttonLandscape = new XBetButton(0);
        this._buttonLandscape.position.set(-18, 148);
        this._buttonLandscape.visible = false;
        this._buttonLandscape.addClickCallback(() => {
            SerialSound.soundPlayer.playTrack({name : this.selected ? SerialSound.XBET_ON : SerialSound.XBET_OFF});
            if(!this.selected) {
                Serial.apiPlugin.betFeatureController.setActiveBetFeature("BOOSTED_BET");
                this._buttonLandscape.playSparks();
            } else {
                Serial.apiPlugin.betFeatureController.setActiveBetFeature();
            }
        });
        this.addChild(this._buttonLandscape);

        this._buttonPortrait = new XBetButton(1);
        this._buttonPortrait.position.set(660, 24);
        this._buttonPortrait.visible = false;
        this._buttonPortrait.addClickCallback(() => {
            SerialSound.soundPlayer.playTrack({name : this.selected ? SerialSound.XBET_ON : SerialSound.XBET_OFF});
            if(!this.selected) {
                Serial.apiPlugin.betFeatureController.setActiveBetFeature("BOOSTED_BET");
                this._buttonPortrait.playSparks();
            } else {
                Serial.apiPlugin.betFeatureController.setActiveBetFeature();
            }
        });
        this.addChild(this._buttonPortrait);

        const featureData = SlotGame.apiPlugin.bonusFeatures.getFeatureDataByName(this.boostedName);
        if(featureData) {
            this._boostedData = {featureName : this.boostedName, price : featureData.price};
        }
        SlotGame.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_START, () => this.onFreeBets(true));
        SlotGame.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => this.onFreeBets(false));


        Serial.apiPlugin.events.on(APIEvent.SELECTED_FEATURE_BET_CHANGED, this.updateState);

    }

    private updateState = ()=> {
        const feature = Serial.apiPlugin.betFeatureController.getActiveBetFeature();
        if (feature?.name == "BOOSTED_BET") {
            this.selected = true;
        }
        else {
            this.selected = false;
        }

    }

    private onFreeBets(value:boolean):void {
        if(value) {
            this._isFreeBet = true;
            this.buttonsVisible = false;
            this.featureEnabled = false;
        } else {
            this._isFreeBet = false;
            this.buttonsVisible = true;
            this.featureEnabled = true;
        }
    }

    public start():void {
        if(!this._featureAllowed) {
            return;
        }

        if(SlotGame.apiPlugin.freeBets.hasFreeBets()) {
            this._isFreeBet = true;
        }

        const nextMode = Serial.model.data.nextMode;
        this.buttonsVisible = nextMode === GameMode.NORMAL || nextMode === GameMode.RESPIN;
        this.featureEnabled = nextMode === GameMode.NORMAL;
    }

    public onOrientationChanged() {
        if(!this._featureAllowed) {
            return;
        }
        this.buttonsVisible = this._buttonsVisible;
        this.featureEnabled = this._featureEnabled;
    }

    public startIdle():void {
        if(!this._featureAllowed) {
            return;
        }
        this._isIdling = true;
        this.playIdleLoop();
    }

    private playIdleLoop():void {
        if(this._idleTl && this._idleTl.isActive()) {
            this._idleTl.pause();
            this._idleTl.kill();
        }
        this._idleTl = null;

        if(!this._isIdling) {
            return;
        }

        const tl = gsap.timeline();
        tl.add(() => {
            const button = NolimitApplication.isLandscape ? this._buttonLandscape : this._buttonPortrait;
            button.playSparks();
            SerialSound.soundPlayer.playTrack({name : SerialSound.XBET_IDLE});
            this.playIdleLoop();
        }, MathHelper.randomNumberInRange(10, 40));
        this._idleTl = tl;
    }

    public stopIdle():void {
        this._isIdling = false;
        if(this._idleTl && this._idleTl.isActive()) {
            this._idleTl.pause();
            this._idleTl.kill();
        }
        this._idleTl = null;
    }
}